// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – animált hang-vizualizáció a hero-ban.
 *
 * Nem vízhullám, hanem spektrum-analizátor stílusú „hangkép": a középtengelyre
 * tükrözött függőleges sávok (equalizer), mögötte egy halvány oszcilloszkóp-vonal.
 * A sávmagasságokat több térbeli és időbeli szinusz szuperpozíciója adja (nem
 * valódi audio, hanem determinisztikus, élénk mozgás), vízszintes meleg → hideg
 * színátmenettel (bal = múlt, jobb = jövő). Additív keveréssel
 * (globalCompositeOperation = 'lighter') a sávok fénylenek a sötét hero-fátyol felett.
 *
 * Az időt a requestAnimationFrame időbélyege adja (nem Date, nem random), így a
 * repo natív-tiltásaival is kompatibilis.
 *
 * Chrome/Edge (Chromium/Skia) alatt a sávonkénti shadowBlur animálva erősen
 * laggol, ezért ott — és prefers-reduced-motion esetén — nem animálunk, csak
 * egyetlen statikus képkockát rajzolunk (a teljes vizuális minőség megmarad).
 * Firefox (Gecko) és a többi nem-Chromium böngésző olcsóbban kezeli a blurt, ott
 * végig fut az animáció.
 */
function initWave() {
  const canvas = document.querySelector('.hero__wave');
  if (canvas === null) {
    return;
  }

  const ctx = canvas.getContext('2d');
  if (ctx === null) {
    return;
  }

  let width = 0;
  let height = 0;
  let gradient = null;

  const resize = () => {
    const dpr = window.devicePixelRatio || 1;
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Vízszintes színátmenet: meleg (múlt) → arany → hideg (jövő).
    gradient = ctx.createLinearGradient(0, 0, width, 0);
    gradient.addColorStop(0, '#e11d2a');
    gradient.addColorStop(0.28, '#ff7a1a');
    gradient.addColorStop(0.5, '#ffc24a');
    gradient.addColorStop(0.72, '#22d3ee');
    gradient.addColorStop(1, '#0ea5b7');
  };

  // Egy pozíció (p: 0..1) „hangereje" adott fázisban: több, eltérő térbeli és
  // időbeli frekvenciájú szinusz szuperpozíciója, a szélek felé halkuló
  // envelope-pal. Az eredmény determinisztikus és mindig a [0..1] tartományban van.
  const magnitude = (p, phase) => {
    const wave =
      Math.sin(p * Math.PI * 2 * 3 + phase * 1.1) * 0.5 +
      Math.sin(p * Math.PI * 2 * 7 - phase * 1.7) * 0.3 +
      Math.sin(p * Math.PI * 2 * 13 + phase * 2.3) * 0.2;
    const envelope = 0.4 + 0.6 * Math.sin(p * Math.PI);
    return envelope * (0.15 + 0.85 * (wave * 0.5 + 0.5));
  };

  // Halvány oszcilloszkóp-vonal a középtengely körül (a sávok mögé kerül).
  const drawScope = (phase, centerY, maxAmp) => {
    ctx.beginPath();

    const step = 4;
    let x = 0;
    while (x <= width) {
      const p = x / width;
      const y = centerY + (magnitude(p, phase) - 0.5) * maxAmp * 1.1;
      if (x === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
      x += step;
    }

    ctx.globalAlpha = 0.22;
    ctx.lineWidth = 2;
    ctx.strokeStyle = gradient;
    ctx.stroke();
  };

  // Tükrözött spektrum-sávok: minden sáv a középtengelyről fel és le is nyúlik.
  const drawBars = (phase, centerY, maxAmp) => {
    const barWidth = 6;
    const gap = 6;
    const stride = barWidth + gap;
    const count = Math.ceil(width / stride);

    ctx.fillStyle = gradient;
    ctx.shadowColor = 'rgba(255, 180, 80, 0.45)';
    ctx.shadowBlur = 8;
    ctx.globalAlpha = 0.7;

    const rounded = typeof ctx.roundRect === 'function';

    let i = 0;
    while (i < count) {
      const x = i * stride;
      const p = count > 1 ? i / (count - 1) : 0;
      const h = Math.max(3, magnitude(p, phase) * maxAmp);
      const y = centerY - h / 2;

      if (rounded === true) {
        ctx.beginPath();
        ctx.roundRect(x, y, barWidth, h, barWidth / 2);
        ctx.fill();
      } else {
        ctx.fillRect(x, y, barWidth, h);
      }

      i += 1;
    }

    ctx.shadowBlur = 0;
  };

  const render = (phase) => {
    ctx.clearRect(0, 0, width, height);

    const centerY = height * 0.52;
    const maxAmp = height * 0.46;

    ctx.globalCompositeOperation = 'lighter';
    drawScope(phase, centerY, maxAmp);
    drawBars(phase, centerY, maxAmp);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
  };

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Könnyűsúlyú böngésző-detektálás: Chrome/Edge (és a többi Chromium/Skia
  // böngésző) alatt a sávonkénti shadowBlur animálva erősen laggol. Az Edge user
  // agentje is tartalmaz "Chrome/"-ot, a Firefox/Safari nem — így ez a minta pont
  // a laggoló motorokat fedi le, extra függőség nélkül.
  const isChromium = /Chrome\//.test(window.navigator.userAgent);

  // Animálunk-e egyáltalán: a Chromium (Skia shadowBlur-lag) és a
  // prefers-reduced-motion felhasználók egyetlen statikus képkockát kapnak.
  const animated = reducedMotion.matches === false && isChromium === false;

  // A statikus képkocka fázisa (a sávok sziluettje). A térbeli frekvenciák miatt
  // bármely érték változatos, élénk spektrumot ad; szabadon hangolható.
  const STATIC_PHASE = 1.6;

  const frame = (timestamp) => {
    // timestamp ezredmásodpercben → élénk, de nem hektikus lüktetés.
    render(timestamp / 700);
    window.requestAnimationFrame(frame);
  };

  // Újramérés a canvas tényleges dobozához, majd statikus módban azonnali
  // újrarajzolás (animált módban a következő rAF-képkocka rajzol úgyis).
  const sync = () => {
    resize();
    if (animated === false) {
      render(STATIC_PHASE);
    }
  };

  // FONTOS: a méretezést a canvas TÉNYLEGES méretéhez kötjük ResizeObserverrel.
  // A main.ts-ben a wave.js a CSS előtt fut le, ezért az initWave induláskor a
  // canvas még stílus nélküli (intrinsic 300×150). Ha a statikus képkockát ezzel
  // a korai mérettel rajzolnánk meg egyszer, a kép kifeszítve/elmosódva rögzülne,
  // és csak egy manuális zoom (ami resize-t vált ki) javítaná. A ResizeObserver
  // viszont az első valós layoutkor (amikor a CSS életbe lép, és a canvas felveszi
  // a végleges méretét) és minden későbbi méretváltozáskor (zoom, ablak-átméretezés)
  // magától újramér és újrarajzol — a window 'resize' erre nem elég, mert az az
  // elem CSS-vezérelt átméreteződésére nem sül el. Ahol nincs ResizeObserver, ott
  // window resize + kezdeti rajzolás a fallback.
  if (typeof window.ResizeObserver === 'function') {
    const sizeObserver = new window.ResizeObserver(sync);
    sizeObserver.observe(canvas);
  } else {
    window.addEventListener('resize', sync);
    sync();
  }

  if (animated === true) {
    window.requestAnimationFrame(frame);
  }
}

initWave();
